export const CatGptItemSets = {
  CATGPT_3A: 'CATGPT_3A',
  CATGPT_3B: 'CATGPT_3B',
  CATGPT_3C: 'CATGPT_3C',
  CATGPT_3A_EXTREME: 'CATGPT_3A_EXTREME',
  CATGPT_3B_EXTREME: 'CATGPT_3B_EXTREME',
  CATGPT_3C_EXTREME: 'CATGPT_3C_EXTREME',
};

export const Game = {
  ID: 'CATGPT',
  OPTIONS: [
    CatGptItemSets.CATGPT_3A,
    CatGptItemSets.CATGPT_3A_EXTREME,
    CatGptItemSets.CATGPT_3B,
    CatGptItemSets.CATGPT_3B_EXTREME,
    CatGptItemSets.CATGPT_3C,
    CatGptItemSets.CATGPT_3C_EXTREME,
  ],
};

export const CoinOpStatus = {
  FINALIZED: 'FINALIZED',
  PROCESSING: 'PROCESSING',
  STARTED: 'STARTED',
};

export const FinaleText = [
  'Generating finale...',
  'Crafting your outcome...',
  'Creating your destiny...',
  'Calculating your conclusion...',
  'Constructing your finale...',
  'Determining your fate...',
  'Formulating your ending...',
  'Designing your final outcome...',
  'Forging your conclusion...',
  'Plotting your ultimate destiny...',
];

export const ChooseText = [
  `Select your path (A, B, or C):`,
  `Make a decision (A, B, or C):`,
  `Which path will you take (A, B, or C)?`,
  `Pick your choice (A, B, or C):`,
  `Time to choose (A, B, or C):`,
  `Your destiny awaits (A, B, or C):`,
  `Decide your fate (A, B, or C):`,
  `Which way will you go (A, B, or C)?`,
  `It's up to you now (A, B, or C):`,
  `The choice is yours (A, B, or C):`,
  'Pick your poison (A, B, or C):',
  'Roll the dice and choose (A, B, or C):',
  'Make your bet (A, B, or C):',
  'Trust your luck (A, B, or C):',
  'Go all-in and decide (A, B, or C):',
  'Take a chance and select (A, B, or C):',
];

// Array of messages for generating adventure
const StartText = [
  'Forging your epic journey...',
  'Unleashing your epic tale...',
  'Crafting your wild adventure...',
  'Formulating your heroic quest...',
  'Generating your daring escapade...',
  'Plotting your thrilling odyssey...',
  'Creating your fantastical saga...',
  'Calculating your epic adventure...',
  'Constructing your action-packed journey...',
  'Designing your unforgettable expedition...',
];

export const randomStartText = () => StartText[Math.floor(Math.random() * StartText.length)];
export const randomFinalText = () => FinaleText[Math.floor(Math.random() * FinaleText.length)];
export const randomChooseText = () => ChooseText[Math.floor(Math.random() * ChooseText.length)];

export const GAME_STEPS = {
  DEPOSIT: 'deposit',
  SETTING: 'setting',
  GAME_START: 'game-start',
  GAME_STEP_1: 'game-step-1',
  GAME_STEP_2: 'game-step-2',
  GAME_CONCLUSION: 'game-conclusion',
  GAME_REWARD: 'game-reward',
};

export const Steps = [
  GAME_STEPS.DEPOSIT,
  // GAME_STEPS.GAME_START,
  GAME_STEPS.GAME_STEP_1,
  // GAME_STEPS.GAME_STEP_2,
  GAME_STEPS.GAME_CONCLUSION,
  GAME_STEPS.GAME_REWARD,
];

export const PromoPageDetail = {
  id: 'promo',
  name: 'Shop',
  icon: 'fa-shop',
  path: '/promos',
};

export const ShopHourPageDetail = {
  id: 'shop-hours',
  name: 'Shop Hours',
  icon: 'fa-clock',
  path: '/shop-hours',
  selectImageUrl: 'https://i.imgur.com/Th0L4Zi.png',
};

export const RFFPageDetail = {
  id: 'rff',
  name: 'Risk Free Plays (RFPs)',
  icon: 'fa-coins',
  path: '/campaigns',
  selectImageUrl: 'https://i.imgur.com/euEgkxy.png',
};

export const DozerPageDetail = {
  id: 'dozer',
  name: 'Dozer Rewards',
  icon: 'fa-gamepad',
  path: '/dozer',
  selectImageUrl: 'https://imgur.com/m7K0Eto.png',
};

export const FragmentsPageDetail = {
  id: 'fragments',
  name: 'Shop Points',
  icon: 'fa-gem',
  path: '/fragments',
};

export const ProfilePageDetail = {
  id: 'profile',
  name: 'KYC Profiles',
  icon: 'fa-shield-halved',
  path: '/kyc-profiles',
  selectImageUrl: 'https://imgur.com/m7K0Eto.png',
};

export const Pages = [
  PromoPageDetail,
  ShopHourPageDetail,
  RFFPageDetail,
  DozerPageDetail,
  FragmentsPageDetail,
  ProfilePageDetail,
];

export const RewardType = {
  SOL: 'SOL',
  RFF: 'RFF',
  DOZER_COIN: 'DOZER_COIN',
  // PHYSICAL_ITEM: 'PHYSICAL_ITEM',
  DIGITAL_ITEM: 'DIGITAL_ITEM',
  NFT: 'NFT',
  // DISCORD_ITEM: 'DISCORD_ITEM',
  // DISCORD_NITRO: 'DISCORD_NITRO',
  USDC: 'USDC',
};

export const PromoType = {
  FRAGMENT: 'FRAGMENT',
  RAFFLE: 'RAFFLE',
  LOSER: 'LOSER',
  VIP: 'VIP',
};

// Display-only qualifying volume per VIP tier (TRU-819, Phase 1).
// NOTE: this is a label for the admin's reference only — actual qualification
// runs off atlantis `VipMinVolume`. The two are independent; if atlantis
// recalibrates (cf. TRU-800), update these by hand. Configurable/editable is
// Phase 2 (TRU-491).
export const VipTierThresholdsSol = {
  BD: 300,
  VVIP: 1000,
};

export const VipTierLabel = {
  BD: 'Big Degen',
  VVIP: 'VVIP',
};

export const LEGAL_WALLETS = [
  'venm6WMaDrLFXGkvEZ2swCfZcy5Rdoh1DThvUEn3aej',
  'HfzcePRo3yXSZUB7z2NdJHyCB9PKqusz63aB75d5NoNy',
  'TestqXotSYZhoAoFGpGxjzwXhrKh5pdgiZzU48vFeoW',
  '21EFMiyqvFF4HWnwa3F1K29ccUJfkxw7qk2jMoR4sTN1',
  '4aoD4ZosrGxv1G6Wn1tRwkhiQHqck4r5gydzCycsLvbR',
  'XXXXXSFD1cH3Rw2Gz2Pip71yt5HFiumXeenMc2b2C3A',
  'Lorsb6aeCAnA15jwKA7yrY8zckwqjPC3HHWnHh8PnuJ',
  'web3oUAjsGdv6QaAeDCqw1T3CqotoRjZFph8JYveWyp',
  'GWGZ2kdCqMSS2fNUay2joLDWHkP87W9mAGbs6SjicEn',
  'CUiPcE9B6ouyFt24NPZDeYqqWFda2Q8myW5aAuLQybDk',
  '5U4rxVGgdNqbJXGDnPYrKHoGGDt8vb3KPdDjRb4CpRj2',
  '65bad9L17xwG7KLUseyCiMZxQjaJVukHJjwmxpqJuVFx',
  'Gfpzg5uMY937TwKYyc4dtiCPJKq3rVYjfoigP3WzzFjP',
  'ted1iuDa4U4pwAxwVuvjbLxJMMPKruqtXkP53sHfqY6',
  'AdminvY7YYHmPufRbJp4yw9ke5XP89BjSNgSB2DsvVWV',
];
